import * as React from "react";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import ModalButtonToolbar from "components/common/ModalButtonToolbar";
import { Spinner } from "components/common";
import { Button } from "components/bootstrap";
const ActionButton = ({
  title,
  onClick,
  bsStyle = void 0,
  setScenarioIsSubmitting,
  scenario,
  scenarioIsSubmitting
}) => {
  const _onClick = async () => {
    setScenarioIsSubmitting(scenario);
    try {
      await onClick();
    } finally {
      setScenarioIsSubmitting(void 0);
    }
  };
  return /* @__PURE__ */ React.createElement(Button, { onClick: _onClick, title, bsStyle, "aria-label": title, disabled: !!scenarioIsSubmitting }, scenarioIsSubmitting === scenario && /* @__PURE__ */ React.createElement(Spinner, { delay: 0, text: "" }), title);
};
const ReportActions = ({
  className = void 0,
  leftCol = void 0,
  submitButtonText,
  onSubmitAndGoToList,
  onSubmit,
  onSubmitAndGenerate
}) => {
  const { t } = useTranslation("enterprise_report");
  const title = typeof submitButtonText === "string" ? submitButtonText : void 0;
  const [scenarioIsSubmitting, setScenarioIsSubmitting] = useState();
  const PerformButton = useCallback(
    ({
      onClick,
      scenario,
      title: buttonTitle,
      bsStyle
    }) => /* @__PURE__ */ React.createElement(
      ActionButton,
      {
        onClick,
        setScenarioIsSubmitting,
        scenarioIsSubmitting,
        scenario,
        title: buttonTitle,
        bsStyle
      }
    ),
    [scenarioIsSubmitting]
  );
  return /* @__PURE__ */ React.createElement(ModalButtonToolbar, { className }, leftCol, /* @__PURE__ */ React.createElement(PerformButton, { onClick: onSubmit, scenario: "submit", bsStyle: "primary", title }), /* @__PURE__ */ React.createElement(
    PerformButton,
    {
      onClick: onSubmitAndGenerate,
      scenario: "submitAndGenerate",
      title: t("report_actions.and_download", { title })
    }
  ), /* @__PURE__ */ React.createElement(
    PerformButton,
    {
      onClick: onSubmitAndGoToList,
      scenario: "submitAndGoToList",
      title: t("report_actions.and_close", { title })
    }
  ));
};
export default ReportActions;
